import { DateRange } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';
import { tzdate, TZDate } from '@repo/tzdate';

/**
 * Converts a DateRange that may contain Dayjs or TZDate values to a DateRange with only TZDate values.
 * This is needed because MUI X v8 date pickers can return either Dayjs or TZDate instances.
 *
 * @param dateRange - DateRange that may contain Dayjs or TZDate values
 * @returns DateRange with only TZDate values
 */
export function convertDateRangeToTZDate(dateRange: DateRange<Dayjs | TZDate>): DateRange<TZDate> {
    return [
        dateRange[0]
            ? dateRange[0] instanceof TZDate
                ? dateRange[0]
                : tzdate(dateRange[0])
            : null,
        dateRange[1]
            ? dateRange[1] instanceof TZDate
                ? dateRange[1]
                : tzdate(dateRange[1])
            : null,
    ] as DateRange<TZDate>;
}
